export type UserRole = "superAdmin" | "admin" | "transporter" | "consignor" | "receiver" | "driver";

export interface User {
  id: string;
  name?: string;
  username: string;
  email: string;
  // The 'role' field is present when we get user from API
  role: UserRole;
  createdAt: string;
  updatedAt: string;
  // You can add more fields if the API returns them
}

/**
 * Get the current user (including role) by extracting the user id from the token in localStorage,
 * then fetching user data from the backend API.
 */
export async function getCurrentUserFromApi(): Promise<User | null> {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    // Decode JWT and extract the user id (assuming standard JWT payload)
    const [, payloadBase64] = token.split(".");
    const payload = payloadBase64
      ? JSON.parse(atob(payloadBase64))
      : null;
    const userId = payload?.userId;
    if (!userId) return null;

    const apiUrl = process.env.REACT_APP_API_URL;

    // Typical query for user info by id, adjust endpoint as needed
    const response = await fetch(
      `${apiUrl}/auth/user/${userId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      }
    );
    if (!response.ok) return null;

    const user = await response.json();
    // Ensure returned object satisfies the User interface (incl. role)
    if (
      typeof user === "object" &&
      typeof user.role === "string"
    ) {
      return user as User;
    }
    return null;
  } catch {
    return null;
  }
}